import React from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import NoteAddIcon from '@mui/icons-material/NoteAdd';

const DescriptionModal = ({ isOpen, onClose, itemId, description, onSave }) => {
  const [newDescription, setNewDescription] = React.useState(description);

  const handleSave = () => {
    onSave(newDescription);
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: 400 },
          maxWidth: 450,
          bgcolor: '#ffffff',
          border: '1px solid #e0e0e0',
          borderRadius: '12px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
          p: 0,
          outline: 'none',
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: { xs: '12px 16px', sm: '16px 20px' },
            borderBottom: '1px solid #e0e0e0',
            background: '#fafafa',
            borderRadius: '12px 12px 0 0',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0.5, sm: 1 } }}>
            <NoteAddIcon sx={{ color: '#56ab2f', fontSize: { xs: 20, sm: 22 } }} />
            <Typography
              id="modal-modal-title"
              sx={{
                fontSize: { xs: 15, sm: 17 },
                fontWeight: 700,
                color: '#2c3e50',
                margin: 0,
              }}
            >
              Item Description
            </Typography>
          </Box>
          <IconButton
            onClick={onClose}
            size="small"
            sx={{
              color: '#7f8c8d',
              padding: { xs: '4px', sm: '8px' },
              '&:hover': {
                background: '#e0e0e0',
              },
            }}
          >
            <CloseIcon sx={{ fontSize: { xs: 18, sm: 20 } }} />
          </IconButton>
        </Box>

        {/* Content */}
        <Box sx={{ padding: { xs: '16px', sm: '20px' } }}>
          <TextField
            label="Add special instructions or notes"
            multiline
            fullWidth
            rows={4}
            value={newDescription}
            onChange={(e) => setNewDescription(e.target.value)}
            variant="outlined"
            placeholder="e.g., No onions, extra spicy, etc."
            sx={{
              marginBottom: 2,
              '& .MuiOutlinedInput-root': {
                borderRadius: '10px',
                fontSize: { xs: '13px', sm: '14px' },
                '& fieldset': {
                  borderColor: '#e0e0e0',
                },
                '&:hover fieldset': {
                  borderColor: '#56ab2f',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#56ab2f',
                },
              },
              '& .MuiInputLabel-root': {
                fontSize: { xs: '13px', sm: '14px' },
                color: '#7f8c8d',
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: '#56ab2f',
              },
            }}
          />

          {/* Buttons */}
          <Box sx={{ 
            display: 'flex', 
            gap: { xs: 1, sm: 1.5 }, 
            justifyContent: 'flex-end',
            flexDirection: { xs: 'column', sm: 'row' }
          }}>
            <Button
              onClick={onClose}
              sx={{
                textTransform: 'none',
                padding: { xs: '10px 16px', sm: '8px 20px' },
                borderRadius: '8px',
                fontSize: { xs: '12px', sm: '13px' },
                fontWeight: 600,
                color: '#7f8c8d',
                border: '1px solid #e0e0e0',
                background: '#ffffff',
                '&:hover': {
                  background: '#f5f5f5',
                  borderColor: '#bdc3c7',
                },
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleSave}
              sx={{
                textTransform: 'none',
                padding: { xs: '10px 16px', sm: '8px 24px' },
                borderRadius: '8px',
                fontSize: { xs: '12px', sm: '13px' },
                fontWeight: 700,
                color: 'white',
                background: 'linear-gradient(135deg, #56ab2f 0%, #a8e063 100%)',
                boxShadow: '0 2px 8px rgba(86, 171, 47, 0.3)',
                '&:hover': {
                  background: 'linear-gradient(135deg, #4a9628 0%, #96d055 100%)',
                  boxShadow: '0 4px 12px rgba(86, 171, 47, 0.4)',
                },
              }}
            >
              Save Note
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default DescriptionModal;
